import React from 'react';
import type { CatalogDirection, CatalogRoleAccess, CatalogService } from '../types';

interface RolePreviewModalProps {
  roleCode: string;
  directions: CatalogDirection[];
  services: CatalogService[];
  roleAccess: CatalogRoleAccess[];
  isOpen: boolean;
  onClose: () => void;
}

export const RolePreviewModal: React.FC<RolePreviewModalProps> = ({
  roleCode,
  directions,
  services,
  roleAccess,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  const allowedServiceIds = new Set(
    roleAccess
      .filter((ra) => ra.role_code === roleCode && ra.service_id && ra.access === 'ALLOWED')
      .map((ra) => ra.service_id as string)
  );

  const visibleServices = services.filter((s) => allowedServiceIds.has(s.service_id));
  const visibleDirectionIds = new Set(visibleServices.map((s) => s.primary_direction_id));
  const visibleDirections = directions.filter((d) => visibleDirectionIds.has(d.direction_id));

  return (
    <div className="cov-modal-overlay" onClick={onClose}>
      <div className="cov-modal-card" style={{ maxWidth: '840px' }} onClick={(e) => e.stopPropagation()}>
        <div className="cov-modal-head">
          <div>
            <h3 style={{ margin: 0, fontSize: '1.125rem' }}>Симуляция интерфейса: «Посмотреть как роль»</h3>
            <span style={{ fontSize: '0.75rem', color: '#64748b' }}>
              Роль: <strong style={{ color: '#38bdf8' }}>{roleCode}</strong> · Read-only превью Этапа 1 мастера создания заявки
            </span>
          </div>
          <button className="cov-btn cov-btn-outline" onClick={onClose}>✕</button>
        </div>

        <div className="cov-modal-body">
          {visibleDirections.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '3rem 1rem', color: '#ef4444' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>✕</div>
              <h4 style={{ margin: '0 0 0.5rem 0', color: '#fff' }}>Каталог заявок недоступен</h4>
              <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.875rem' }}>
                Для роли <strong>{roleCode}</strong> все направления и услуги запрещены политикой доступа.
              </p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.8125rem', color: '#94a3b8' }}>
                  Доступно направлений: <strong style={{ color: '#fff' }}>{visibleDirections.length}</strong> · Услуг: <strong style={{ color: '#fff' }}>{visibleServices.length}</strong>
                </span>
                <span className="cov-role-badge cov-badge-allowed">Разрешённые объекты</span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {visibleDirections.map((dir) => {
                  const srvList = visibleServices.filter((s) => s.primary_direction_id === dir.direction_id);
                  return (
                    <div key={dir.direction_id} style={{ background: '#131d31', border: '1px solid #1e293b', borderRadius: '8px', padding: '0.875rem' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                        <span className="cov-dir-code">{dir.display_code}</span>
                        <strong style={{ fontSize: '0.9375rem', color: '#f1f5f9' }}>{dir.title}</strong>
                        <span style={{ fontSize: '0.75rem', color: '#64748b' }}>({srvList.length} услуг)</span>
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '0.5rem' }}>
                        {srvList.map((srv) => (
                          <div
                            key={srv.service_id}
                            style={{
                              background: '#0f172a',
                              border: '1px solid #1e293b',
                              borderRadius: '6px',
                              padding: '0.5rem 0.75rem',
                              fontSize: '0.8125rem',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.2rem',
                            }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <span style={{ color: '#f59e0b', fontWeight: 600 }}>{srv.display_code}</span>
                              <span style={{ color: '#64748b', fontSize: '0.6875rem' }}>{srv.route}</span>
                            </div>
                            <span style={{ color: '#e2e8f0', fontWeight: 500 }}>{srv.title}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="cov-modal-foot">
          <button className="cov-btn cov-btn-outline" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
};
